import { isBranded } from '@/helpers/isBranded'

export default {
  computed: {
    isBranded () {
      return isBranded(this.$route.query)
    }
  }
}
